/* Toasts on Soft (style lab /test/style-v3, final round 6, 2026-10-09): one
   height, 40; as wide as the words; 13px; the body a raised capsule (#242424)
   with the 1px highlight, no frame; the status mark plain, no plate under it —
   Phosphor's check and exclamation in a circle, the notch turning while
   pending; the tail is the time, then the link mark. The stack is centred at
   the top. */

.stack {
  position: fixed;
  /* manual-popover: сброс UA-центровки (inset:0 + margin:auto) — ДО top/left */
  margin: 0;
  inset: auto;
  top: 14px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 90; /* фоллбэк без popover; в top-layer z-index не участвует */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  border: none;
  background: transparent;
  padding: 0;
  max-width: none;
  max-height: none;
  overflow: visible;
}

/* корпус — однострочный, ширина ПО КОНТЕНТУ; вход сверху + fade,
   transitions (не keyframes) — стек добавляется часто, ретаргет плавный */
.toast {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  height: 40px;
  padding: 0 14px 0 12px;
  font-family: var(--font-soft);
  font-size: 13px;
  font-weight: var(--fw-label);
  color: var(--soft-text);
  white-space: nowrap;
  cursor: pointer;
  background: var(--soft-raised);
  border: 0;
  border-radius: 999px;
  box-shadow: var(--soft-hl-soft);
  opacity: 1;
  transform: translateY(0);
  transition: opacity 200ms cubic-bezier(0.23, 1, 0.32, 1), transform 200ms
    cubic-bezier(0.23, 1, 0.32, 1);
}
@starting-style {
  .toast {
    opacity: 0;
    transform: translateY(-12px);
  }
}
.toast[data-leaving] {
  opacity: 0;
  transform: translateY(-8px);
  transition-duration: 160ms;
}
.toast:focus-visible {
  outline: 2px solid var(--soft-focus);
  outline-offset: 2px;
}

/* ---- Алерт трекнутого кошелька (финал лабы #196): тот же пиксель-корпус,
   но двухэтажный, с аватаром токена слева и контролами столбиком справа.
   Живёт в ТОМ ЖЕ стеке (сверху по центру) — одна семья нотификаций. ---- */
.alertCard {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  padding: 9px 12px 9px 10px;
  font-family: var(--font-soft);
  font-weight: var(--fw-label);
  color: var(--soft-text);
  white-space: nowrap;
  background: var(--soft-raised);
  border: 0;
  border-radius: 18px;
  box-shadow: var(--soft-hl-soft);
  opacity: 1;
  transform: translateY(0);
  transition: opacity 200ms cubic-bezier(0.23, 1, 0.32, 1), transform 200ms
    cubic-bezier(0.23, 1, 0.32, 1);
}
@starting-style {
  .alertCard {
    opacity: 0;
    transform: translateY(-12px);
  }
}
.alertCard[data-leaving] {
  opacity: 0;
  transform: translateY(-8px);
  transition-duration: 160ms;
}
/* тело алерта кликабельно целиком (открыть токен), контролы — рядом */
.aOpen {
  display: inline-flex;
  align-items: center;
  gap: 11px;
  padding: 0;
  border: 0;
  background: none;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.aArt {
  position: relative;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
}
.aBody {
  display: grid;
  gap: 2px;
  min-width: 0;
}
.aTop {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}
.aWho {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}
/* глаголы — цветом события (финал лабы) */
.aTop i {
  font-style: normal;
  color: var(--soft-text-2);
}
.aTop i[data-tone="buy"] {
  color: var(--trades-buy);
}
.aTop i[data-tone="sell"] {
  color: var(--trades-sell);
}
.aTop i[data-tone="transfer"] {
  color: var(--accent-bright);
}
.aMark {
  display: inline-grid;
  place-items: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--soft-fill);
  border: 1px solid var(--soft-menu-line);
  font-size: 8.5px;
  font-weight: var(--fw-num);
  color: var(--soft-text-2);
}
.aName,
.aTicker {
  font-weight: var(--fw-num);
}
/* the alert's first line, cut to its capitals (soft.fig, 2026-11-03): the
   wallet's disc on the middle of its name, the verb and the ticker on the same
   line; the disc's letter on the middle of the disc. The line keeps its
   height. */
.aName,
.aTop i,
.aTicker,
.aMark {
  /* biome-ignore lint/correctness/noUnknownProperty: CSS Text 4 text-box, in Chrome 133+ and Safari 18.2+ */
  text-box: trim-both cap alphabetic;
  font-feature-settings: "case"; /* its dashes on the capitals' middle (Wils Case Dash, tokens.css) */
}
.aTop {
  min-height: 1lh;
}
.aMeta {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  color: var(--soft-text-2);
}
.aMeta b {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: var(--fw-num);
}
.aMeta b[data-tone="buy"] {
  color: var(--trades-buy);
}
.aMeta b[data-tone="sell"] {
  color: var(--trades-sell);
}
.aMeta b[data-tone="transfer"] {
  color: var(--accent-bright);
}
.aAddr {
  font-size: 11px;
  font-weight: var(--fw-label);
  color: var(--soft-muted);
}
/* контролы столбиком — финал: ✕ сверху, колокол снизу, прижаты к верху */
.aCtl {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  align-self: flex-start;
  gap: 3px;
  margin-left: 10px;
  margin-top: -2px;
}
.aBell,
.aClose {
  display: inline-grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border: 0;
  background: transparent;
  cursor: pointer;
  transition: color 0.12s ease;
}
.aClose {
  color: var(--soft-muted);
}
.aClose:hover {
  color: #ffffff;
}
.aBell {
  color: var(--soft-text);
}
.aBell[data-on="true"] {
  color: var(--accent-bright);
}

.tIcon {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
}
/* a mark the caller brings (the copy toast's) is the dim one, never green */
.tIconCustom {
  color: var(--soft-text-2);
}
/* gap 4 — канон отступов: слова/тикер плотнее (фидбек) */
.tText {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.tText b {
  font-weight: var(--fw-num);
}
/* The close of a failed toast (its body does not dismiss, 2026-08-29) and of
   the copy toast: a ghost disc, 24, pulled into the capsule's end so the mark
   keeps the side every toast has. */
.tClose {
  flex: 0 0 auto;
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  margin: 0 -6px 0 4px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--soft-muted);
  cursor: pointer;
  transition: background-color 0.15s var(--soft-ease), color 0.15s var(--soft-ease);
}
.tClose:hover {
  background: var(--soft-raised-hover);
  color: #ffffff;
}
.tClose:focus-visible {
  outline: 2px solid var(--soft-focus);
  outline-offset: 0;
}
/* The tail: the time, muted, then the link mark a step lighter — on the words'
   optical line. The whole toast is what opens the link, so the mark answers
   the pointer anywhere on it. */
.tTail {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 2px;
  font-size: 12px;
  font-weight: var(--fw-num);
  line-height: 16px;
  color: var(--soft-muted);
}
.tTail svg {
  display: block;
  color: var(--soft-text-2);
  transition: color 0.15s var(--soft-ease);
}
.toast:hover .tTail svg {
  color: #ffffff;
}

/* the status marks: plain, no plate under them (the lab's .up and .down) */
.okInk {
  color: var(--soft-up);
  animation: markIn 180ms var(--soft-ease) both;
}
.failInk {
  color: var(--soft-down);
  animation: markIn 180ms var(--soft-ease) both;
}
@keyframes markIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* The Soft spinner: Phosphor's notch, one turn in 0.8s. It takes the colour of
   where it stands (currentColor); in a toast that is the accent's ink. */
.spin {
  display: inline-grid;
  place-items: center;
}
.spin svg {
  display: block;
  animation: spinTurn 0.8s linear infinite;
}
.tIcon .spin {
  color: var(--soft-accent-ink);
}
@keyframes spinTurn {
  to {
    transform: rotate(360deg);
  }
}

/* The pixel spinner of lab #196 — eight squares, a wave in 0.8s. The toasts no
   longer wear it; Instant Trade's quick buttons do while they cool down, in
   their side's colour (--px-spin). */
.pxSpin {
  position: relative;
  width: 18px;
  height: 18px;
}
.pxSpin i {
  position: absolute;
  width: 3px;
  height: 3px;
  background: var(--px-spin, var(--accent-bright));
  opacity: 0.18;
  animation: pxWave 0.8s linear infinite;
}
.pxSpin i:nth-child(1) {
  left: 7.5px;
  top: 0;
  animation-delay: -0.8s;
}
.pxSpin i:nth-child(2) {
  left: 13px;
  top: 2.2px;
  animation-delay: -0.7s;
}
.pxSpin i:nth-child(3) {
  left: 15px;
  top: 7.5px;
  animation-delay: -0.6s;
}
.pxSpin i:nth-child(4) {
  left: 13px;
  top: 13px;
  animation-delay: -0.5s;
}
.pxSpin i:nth-child(5) {
  left: 7.5px;
  top: 15px;
  animation-delay: -0.4s;
}
.pxSpin i:nth-child(6) {
  left: 2.2px;
  top: 13px;
  animation-delay: -0.3s;
}
.pxSpin i:nth-child(7) {
  left: 0;
  top: 7.5px;
  animation-delay: -0.2s;
}
.pxSpin i:nth-child(8) {
  left: 2.2px;
  top: 2.2px;
  animation-delay: -0.1s;
}
/* бегущий огонёк с хвостом: яркая точка + полуяркий след */
@keyframes pxWave {
  0%,
  12.4% {
    opacity: 1;
  }
  12.5%,
  24.9% {
    opacity: 0.55;
  }
  25%,
  100% {
    opacity: 0.18;
  }
}

@media (prefers-reduced-motion: reduce) {
  .toast,
  .toast[data-leaving] {
    transition: opacity 150ms ease;
    transform: none;
  }
  .pxSpin i {
    animation: none !important;
    opacity: 0.7;
  }
  .okInk,
  .failInk {
    animation: none !important;
    opacity: 1;
  }
  .spin svg {
    animation-duration: 1.6s;
  }
}
